import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "backgroundColor moreProductInfoWrap" }
const _hoisted_2 = { class: "productImageWrap" }
const _hoisted_3 = { style: {"float":"left","margin-top":"20%"} }
const _hoisted_4 = { style: {"float":"right","margin-top":"20%"} }
const _hoisted_5 = ["data-id", "src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "ECE-R90:", -1)
const _hoisted_13 = { style: {"float":"left"} }
const _hoisted_14 = {
  div: "",
  style: {"float":"left","padding-top":"2px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  div: "",
  style: {"clear":"both"}
}, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}

import { computed,onMounted,reactive, watch } from 'vue'
import { ElTable } from 'element-plus'
import $http from '../http/index'
import $helper from '../helper/helper';

interface ButtonInfo {
    type: string,
    text: string,
    icon: string,
    code: string
}

interface PD_ItemParameterEntity{
    ID:string,
    ItemModelID:string,
    FieldCode:string,
    FieldName:string,
    FieldValuesString:string,
    FieldValuesStrings:string[]
}

interface Relevance{
    // 型号关系
    Similar:string,
    // 对应型号
    PartNo:string,
    // 区别说明
    Difference:string
}

interface OtherFeature{
    // 产品分类
    ProductClassify:string,
    // 包装数量
    PackageCount:string,
    // ECER90
    ECER90:string
}

interface BrandProduct{
    Brands:string,
    BrandsModel:string,
    U9Code:string,
    Status:string,
    Series:string,
    Code69Info:string,
    ProductNote:string,
    PriceGuidance:string,
    PriceMedia:string
}

interface CarModelBaoYouLiang{
    BaoYouLiangPID:string,
    BaoYouLiang:string
}

// 车型匹配
interface CarModelsInfoMatch{
    ID:string
    // 车型详细信息
    carInfo:string,
    // 品牌 
    Brands:string,
    // 车型 
    CarModel:string,
    CarModelEn:string,
    // 排量 
    OutputVolume:string,
    // 车辆类别 
    VehicleType:string,
    // 驱动方式
    DrivingModel:string,
    // 上市时间
    SaleTime:string,
    // 上市年份
    SaleYear:string,
    // 上市月份
    SaleMonth:string,
    // 停产时间
    StopTime:string,
    // 停产年份
    StopYear:string,
    // 停产月份
    StopMonth:string,
    // 前刹车 
    BrakeFront:string,
    // 后刹车 
    BrakeAfter:string,
    // 手刹片 
    HandBrake:string,
    // 前刹车盘 
    BrakeDiscFront:string,
    // 后刹车盘 
    BrakeDiscAfter:string,
    // 前报警线
    AlarmLineFront:string,
    // 后报警线
    AlarmLineAfter:string,
    // 车型匹配编号区别 
    Note:string,
    // 保有量 
    Retention:string,
    // 市场来源
    MarketSource:string,
    // 车厂
    Factory:string,
    FactoryEn:string,
    // 第三方保有量
    OtherRetention:number,
    // 第三方保有量明细
    OtherRetentionDetail:Array<CarModelBaoYouLiang>,
}

// 品牌编码
interface BrandCode{
    MCType:string,
    BrandsOther:string,
    OtherCode:string,
    Remark:string
}

// 产品图片
interface PictureFile{
    ID:string,
    PictureFileURL:string
}

//省份与城市
interface ProvinceAndCity{
    Province:string,
    City:string
}

interface MoreProductInfoDTO{
    ProductSize:PD_ItemParameterEntity[],
    Relevances:Relevance[],
    OtherFeatures:OtherFeature[],
    BrandProducts:BrandProduct[],
    CarModelsInfoMatchs:CarModelsInfoMatch[],
    BrandCodes:BrandCode[],
    PictureFiles:PictureFile[],
    TotalRetention:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailProductInfo',
  props: {
    gloryModel: null,
    typeCode: null
  },
  setup(__props: any) {

const props = __props as {
    gloryModel: string,
    typeCode:string
};

class InitData{
    moreProductInfoDTO:MoreProductInfoDTO={
        ProductSize:[],
        Relevances:[],
        OtherFeatures:[],
        BrandProducts:[],
        CarModelsInfoMatchs:[],
        BrandCodes:[],
        PictureFiles:[],
        TotalRetention:''
    };
    productTypes: Array<ButtonInfo> = [
        { type: '', text: '附件包', code: "AnnexPackge", icon: '' },
        { type: '', text: '报警线', code: "WarnLine", icon: '' },
        { type: '', text: '刹车盘', code: "BrakeDisc", icon: '' },
        { type: '', text: '手刹片', code: "HandBrake", icon: '' },
        { type: '', text: '刹车片', code: "BrakePads", icon: '' },
    ];
    productTypesChecked:string[]=[];
    ProductSizesShow:PD_ItemParameterEntity[]=[];
    OperateType="product";
    MarketSource="";
    MarketSources:string[]=[];
    DetailSearch="";
    ShowCarModelsInfoMatchs:CarModelsInfoMatch[]=[];
    showProdyctImageIndex=-1;
    TotalRetention='';
    procudtCodes:Array<string>=[] //已有的产品编码
    OperateTypeCheckSatyle='background-color:red'
    provinceAndCity:Array<ProvinceAndCity>=[] //省份和城市
    province=''
    city:Array<string>=[]
    baoYouLiangYear:Array<string>=[] //保有量年
    baoYouLiangYears:Array<string>=[]
    lanType="CN"
}

const productTypesClick=(t:string)=>{
    let index = data.productTypesChecked.indexOf(t);
    if(index > -1){
        data.productTypesChecked.splice(index,1);
        return;
    }
    data.productTypesChecked.push(t);
}

const data = reactive(new InitData());

const createID = ()=>{
    return Date.now() + "_" + Math.random().toString(36);
}

const collapseShow = ['1','2','3','4'];



onMounted(() => {
    data.lanType='CN';
    const lanType=window.localStorage.getItem('lanType');
    if(lanType){
        data.lanType=lanType;
    }
    const brandDecoration = $helper.getBrandDecoration();
    if(brandDecoration.BrandInputColor){
        data.OperateTypeCheckSatyle=`background-color:#${brandDecoration.BrandInputColor}`;
    }  
    //产品类别
    if(brandDecoration.ProductTypes){
        const types = brandDecoration.ProductTypes.split(',')
        const showProductTypes:Array<ButtonInfo> =[];
        for(let i=0;i<data.productTypes.length;i++){
        const index = types.findIndex(c=>c==data.productTypes[i].code);
        if(index>-1){
            showProductTypes.push(data.productTypes[i])
        }
        }
        data.productTypes = showProductTypes;
    }
    getAllProcudtCode();
    dataInit();
    getProvinceAndCity();
    getBaoYouliangYears();
})

const dataInit = ()=>{
    data.productTypesChecked.push(props.typeCode);
    if(props.typeCode=="ParkingBrakeShoe"){
        data.productTypesChecked.push("BrakeShoe");
    }
    $http({
        url: `/API/Product/GetMoreProductInfo?gloryModel=${props.gloryModel}&typeCode=${props.typeCode}`,
        method: "GET",
        data: {
        }
    }).then(res => {
        data.moreProductInfoDTO = res.data;
        // 处理查询详细信息
        for(let i=0;i<data.moreProductInfoDTO.CarModelsInfoMatchs.length;i++){
            let match =data.moreProductInfoDTO.CarModelsInfoMatchs[i];
            const lanType = window.localStorage.getItem('lanType')
            if(!lanType || lanType=="CN"){
                match.carInfo = `${match.Factory} ${match.CarModel} ${match.OutputVolume} ${match.VehicleType} ${match.DrivingModel}`;
                const times:Array<string> =[]; 
                if(match.SaleTime){
                    times.push(match.SaleTime)
                }
                if( match.StopTime){
                    times.push(match.StopTime)
                }
                match.carInfo = `${match.carInfo} ${times.join('~')}`;
            }
            if(lanType=="EN"){
                match.carInfo = `${match.FactoryEn} ${match.CarModelEn} ${match.OutputVolume} ${$helper.lan(match.VehicleType)} ${$helper.lan(match.DrivingModel)}`;
                const times:Array<string> =[]; 
                if(match.SaleTime){
                    times.push($helper.convertDate(match.SaleTime));
                }
                if( match.StopTime){
                    times.push($helper.convertDate(match.StopTime));
                }
                match.carInfo = `${match.carInfo} ${times.join('~')}`;
            }
        }
        // 处理市场来源
        for(let i=0;i<data.moreProductInfoDTO.CarModelsInfoMatchs.length;i++){
        let match =data.moreProductInfoDTO.CarModelsInfoMatchs[i];
        if(!match.MarketSource || data.MarketSources.indexOf(match.MarketSource)>-1){
            continue
        }
        data.MarketSources.push(match.MarketSource);
        }
        CarModelsInfoMatchSearch();

        // 处理图片URL
        for(let i=0;i<data.moreProductInfoDTO.PictureFiles.length;i++){
            let file = data.moreProductInfoDTO.PictureFiles[i];
            file.PictureFileURL = `${process.env.VUE_APP_BASE_API}/API/Product/GetImageFileSpecifySize?fileId=${file.ID}&width=800&height=570&watermarkSize=180&domainName=${$helper.getDomainName()}`;
        }

        //显示产品图片
        if(data.moreProductInfoDTO.PictureFiles && data.moreProductInfoDTO.PictureFiles.length>0){
        data.showProdyctImageIndex=0;
        }

        // 处理尺寸显示
        if(data.moreProductInfoDTO.ProductSize && data.moreProductInfoDTO.ProductSize.length>0){
            let productSizes = data.moreProductInfoDTO.ProductSize;
            let itemModelIDs:string[] = []
            let fieldCodes:string[] = []
            let fieldNames:string[] = []
            for(let i=0;i<productSizes.length;i++){
            if(itemModelIDs.indexOf(productSizes[i].ItemModelID)<0){
                itemModelIDs.push(productSizes[i].ItemModelID);
            }
            if(fieldCodes.indexOf(productSizes[i].FieldCode)<0){
                fieldCodes.push(productSizes[i].FieldCode);
                fieldNames.push(productSizes[i].FieldName);
            }
            }
            let productSizeShow:PD_ItemParameterEntity[] = [];
            for(let i=0;i<fieldCodes.length;i++){
            let fieldCode = fieldCodes[i];
            let fieldName = fieldNames[i];
            let productSize:PD_ItemParameterEntity={
                ID:`productSizeShowID${i}`,
                ItemModelID:'',
                FieldCode:fieldCode,
                FieldName:fieldName,
                FieldValuesString:'',
                FieldValuesStrings:[]
            };
            for(let j=0;j<itemModelIDs.length;j++){
                let itemModelID = itemModelIDs[j]
                let currentSize = productSizes.filter(c=>c.FieldCode==fieldCode&&c.ItemModelID==itemModelID);
                if(currentSize.length>0){
                productSize.FieldValuesStrings.push(currentSize[0].FieldValuesString);
                }else{
                productSize.FieldValuesStrings.push('&nbsp;');
                }
            }
            productSizeShow.push(productSize);
        }
        data.ProductSizesShow = productSizeShow;
        }

        // 处理关联特征(去重)
        let relevances:Array<Relevance> = [];
        for(let i=0;i<data.moreProductInfoDTO.Relevances.length;i++){
            let relevance = data.moreProductInfoDTO.Relevances[i]
            let index = relevances.findIndex(c=>c.Difference ==relevance.Difference && c.PartNo==relevance.PartNo && c.Similar == relevance.Similar)
            if(index <0){
                relevances.push(relevance);
            }
        }
        data.moreProductInfoDTO.Relevances = relevances;

    }).finally(() => {
        window.setTimeout(() => {
        //data.loading = false
        }, 500);
    })
}

// 车型查询条件重置
const searchReset = ()=>{
    data.MarketSource = '';
    data.DetailSearch = '';
    data.province = '';
    data.city=[];
    data.baoYouLiangYear=[];
    CarModelsInfoMatchSearch();
}

// 车型信息
const CarModelsInfoMatchSearch=()=>{
    CarModelsInfoMatchSearchPageCalulate();
    baoYouLiangSearch();
}

const CarModelsInfoMatchSearchPageCalulate=()=>{
    let show:CarModelsInfoMatch[] = [];
    for(let i=0;i<data.moreProductInfoDTO.CarModelsInfoMatchs.length;i++){
        let match =data.moreProductInfoDTO.CarModelsInfoMatchs[i];
        if(data.MarketSource && match.MarketSource!=data.MarketSource){
        continue;
        }
        if(data.DetailSearch && match.carInfo && match.carInfo.toLocaleLowerCase().indexOf(data.DetailSearch.toLocaleLowerCase())<0){
        continue;
        }
        show.push(match);
    }
    data.ShowCarModelsInfoMatchs = show;
    //统计保有量总数
    let total = 0;
    let pIDs:Array<string>=[];
    for(let i=0;i<data.ShowCarModelsInfoMatchs.length;i++){
        let match = data.ShowCarModelsInfoMatchs[i];
        for(let j=0;match.OtherRetentionDetail && j<match.OtherRetentionDetail.length;j++){
        let detail = match.OtherRetentionDetail[j];
        if(pIDs.indexOf(detail.BaoYouLiangPID)>-1){
            continue;
        }
        pIDs.push(detail.BaoYouLiangPID);
        total = total + Number.parseInt(detail.BaoYouLiang);
        }
    }
    
    data.TotalRetention = $helper.commafy(total);
};

// 计算缩小图片的尺寸
const calWidthAndHeight = (width:number, height:number, maxWidth:number, maxHeight:number):any=>{
    let calWidth = width;
    let calHeight = height;
    if (calHeight >= maxHeight || calWidth >= maxWidth) {
        if (calHeight > maxHeight) { //高度超最大高度,使用最大高度并缩小宽度
            calWidth = calWidth * maxHeight / calHeight;
            calHeight = maxHeight;
        }
        if (calWidth > maxWidth) {//宽度超最大宽度,使用最大宽度并缩小高度
            calHeight = calHeight * maxWidth / calWidth;
            calWidth = maxWidth;
        }
        return {
            calWidth: calWidth,
            calHeight: calHeight
        }
    }
    return {
        calWidth: calWidth,
        calHeight: calHeight
    }
}

// 画图
const drawImage = (imgObj:HTMLImageElement, maxWidth:number, maxHeight:number) => {
    var image = new Image();
    image.src = imgObj.src;
    if (image.width > 0 && image.height > 0) {
        let height = image.height;
        let width = image.width;
        let size = calWidthAndHeight(width, height, maxWidth, maxHeight);
        imgObj.width = size.calWidth;
        imgObj.height = size.calHeight;
    }
}

// 产品图片大小适配
const productImageOnload = (e: Event)=>{
    const target = e.target as HTMLImageElement;
    drawImage(target,750,500);
}

// 图片展示切换
const productImageUpdate = (operate:string)=>{
    if(operate =="s" && data.showProdyctImageIndex>0){
        data.showProdyctImageIndex = data.showProdyctImageIndex -1;
    }
    if(operate =="a" && data.showProdyctImageIndex<data.moreProductInfoDTO.PictureFiles.length-1){
        data.showProdyctImageIndex = data.showProdyctImageIndex + 1;
    }
}

watch(()=>`${props.gloryModel}${props.typeCode}`,()=>{
    data.productTypesChecked=[];
    dataInit();
})

/**
 * 保有量数据格式化
 * @param retention 
 */
const OtherRetentionFormat=(retention:number)=>{
    let r = $helper.commafy(retention);
    if(r=="0"){
        return "";
    }
    return r;
}

const brandCodeshow = computed(()=>{
    const mCTypes:Array<string> = [];
    if($helper.hasPermission('OEInfoM')){
        mCTypes.push('M');
    }
    if($helper.hasPermission('OEInfoC')){
        mCTypes.push('C');
    }
    const brands:Array<BrandCode> = [];
    for(let i=0;i<data.moreProductInfoDTO.BrandCodes.length;i++){
        const item = data.moreProductInfoDTO.BrandCodes[i];
        if(mCTypes.includes(item.MCType)){
            brands.push(item)
        }
    }
    return brands;
})

const brandProductshow = computed(()=>{
    const userBrands = $helper.getUserBrands();
    const brandProducts:Array<BrandProduct> = [];
    for(let i=0;i<data.moreProductInfoDTO.BrandProducts.length;i++){
        const item = data.moreProductInfoDTO.BrandProducts[i];
        if(!userBrands.includes(item.Brands)){
            continue;
        }
        brandProducts.push(item)
    }
    return brandProducts;
})

const getAllProcudtCode =()=>{
    if(data.procudtCodes.length>0){
        return;
    }
    $http({
        url: "/API/Product/AllProcudtCode",
        method: "POST",
        data: {
        }
    }).then(res => {
        data.procudtCodes = res.data;
    })
}

/**
 * 获取省份和城市
 */
const getProvinceAndCity=()=>{
    $http({
        url: "/API/Product/GetAllProvinceAndCity",
        method: "POST",
        data: {
        }
    }).then(res => {
        data.provinceAndCity = JSON.parse(JSON.stringify(res.data));
    })
}

/**
 * 获取省份
 */
const getProvinces = computed(()=>{
    let provinces:Array<string> = [];
    for(let i=0;data.provinceAndCity && i<data.provinceAndCity.length;i++){
        let item = data.provinceAndCity[i];
        if(provinces.indexOf(item.Province)>-1){
            continue;
        }
        provinces.push(item.Province);
    }
    return provinces;    
})

/**
 * 获取城市
 */
const getCities = computed(()=>{
    let cities:Array<string> = [];
    for(let i=0;data.provinceAndCity && i<data.provinceAndCity.length;i++){
        let item = data.provinceAndCity[i];
        if(item.Province!=data.province){
            continue;
        }
        if(cities.indexOf(item.City)>-1){
            continue;
        }
        cities.push(item.City);
    }
    return cities;    
})

/**
 * 保有量年份
 */
const getBaoYouliangYears = ()=>{
    $http({
        url: "/API/Product/GetBaoYouLiangYears",
        method: "POST",
        data: {
        }
    }).then(res => {
        if(!res){
            return
        }
        data.baoYouLiangYears = JSON.parse(JSON.stringify(res.data));
    })
}

/**
 * 保有量查询操作
 */
const baoYouLiangSearch = () =>{
    const matchIDs:Array<string> = [];
    for(let i=0;i<data.moreProductInfoDTO.CarModelsInfoMatchs.length;i++){
        let match =data.moreProductInfoDTO.CarModelsInfoMatchs[i];
        matchIDs.push(match.ID);
    }
    if(matchIDs.length<1){
        matchIDs.push('NoID');
    }
    let searchID = $helper.createID();
    let serchParam={
        SearchID:searchID,
        Brand:[],
        SaleTimeYear:[],
        DrivingType:[],
        MarketSource:'',
        Factory:[],
        CarModelID:'',
        CarModel:[],
        EngineModel:'',
        SearchCondition:'',
        Province:data.province,
        City:data.city,
        CarUse:[],
        BaoYouLiangYear:data.baoYouLiangYear,
        BaoYouLiangMonth:[],
        MatchIDs:matchIDs.join('|')
    };
    $http({
        url: "/API/Product/MoreProductInfoBaoYouLiangSearch",
        method: "POST",
        data: {
            searchCondition: JSON.stringify(serchParam),
        }
    }).then(res => {
        for(let i=0;i<res.data.length;i++){
            let baoYouLiangMatch =res.data[i]; 
            let index = data.moreProductInfoDTO.CarModelsInfoMatchs.findIndex(c=>c.ID==baoYouLiangMatch.ID);
            if(index<0){
                data.moreProductInfoDTO.CarModelsInfoMatchs[index].OtherRetention=0;
                data.moreProductInfoDTO.CarModelsInfoMatchs[index].OtherRetentionDetail=[];
            }else{
                data.moreProductInfoDTO.CarModelsInfoMatchs[index].OtherRetention=baoYouLiangMatch.OtherRetention;
                data.moreProductInfoDTO.CarModelsInfoMatchs[index].OtherRetentionDetail=baoYouLiangMatch.OtherRetentionDetail;
            }
        }
        CarModelsInfoMatchSearchPageCalulate();
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, { height: "600px" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse, {
          modelValue: collapseShow,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((collapseShow) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, { name: "1" }, {
              title: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('图片信息')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  class: "MoreProductInfoRow",
                  style: {"padding-top":"0px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _withDirectives(_createVNode(_component_el_button, {
                              type: "primary",
                              icon: "DArrowLeft",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (productImageUpdate('s')))
                            }, null, 512), [
                              [_vShow, data.showProdyctImageIndex>0]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createVNode(_component_el_button, {
                              type: "primary",
                              icon: "DArrowRight",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (productImageUpdate('a')))
                            }, null, 512), [
                              [_vShow, data.showProdyctImageIndex<data.moreProductInfoDTO.PictureFiles.length-1]
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.moreProductInfoDTO.PictureFiles, (item) => {
                            return _withDirectives((_openBlock(), _createElementBlock("img", {
                              key: item.ID,
                              "data-id": item.ID,
                              alt: "Product Image",
                              class: "productImage",
                              src: item.PictureFileURL,
                              onLoad: productImageOnload
                            }, null, 40, _hoisted_5)), [
                              [_vShow, data.moreProductInfoDTO.PictureFiles[data.showProdyctImageIndex].ID ==item.ID]
                            ])
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, { name: "2" }, {
              title: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('产品特征')), 1)
              ]),
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_row, { class: "MoreProductInfoRow" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 2,
                      class: "MoreProductInfoDescript"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($helper).lan('尺寸特征')) + ":", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 22 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.ProductSizesShow, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "MoreProductInfoProductSize",
                            key: item.ID
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.FieldName), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.FieldValuesStrings, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size+createID(),
                                innerHTML: size
                              }, null, 8, _hoisted_6))
                            }), 128))
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, data.moreProductInfoDTO.ProductSize.length>0?true:false]
                ]),
                _withDirectives(_createVNode(_component_el_row, { class: "MoreProductInfoRow" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 2,
                      class: "MoreProductInfoDescript"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($helper).lan('关联特性')) + ":", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElTable), {
                          data: data.moreProductInfoDTO.Relevances,
                          style: {"width":"700px"},
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "Similar",
                              label: _unref($helper).lan('型号关系'),
                              width: "200"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_unref($helper).lan(scope.row.Similar)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "PartNo",
                              label: _unref($helper).lan('对应型号'),
                              width: "200"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "Difference",
                              label: _unref($helper).lan('区别说明'),
                              width: "300"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_unref($helper).lan(scope.row.Difference)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, data.moreProductInfoDTO.Relevances.length>0?true:false]
                ]),
                (data.moreProductInfoDTO.OtherFeatures.length>0)
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 0,
                      class: "MoreProductInfoRow"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 2,
                          class: "MoreProductInfoDescript"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($helper).lan('其他特征')) + ":", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 20,
                          style: {"padding-left":"10px","font-size":"14px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (data.moreProductInfoDTO.OtherFeatures[0].ProductClassify)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('产品分类')) + ":", 1),
                                    _createTextVNode(" "),
                                    _createElementVNode("span", null, _toDisplayString(data.moreProductInfoDTO.OtherFeatures[0].ProductClassify), 1),
                                    _createTextVNode("    ")
                                  ]))
                                : _createCommentVNode("", true),
                              (data.moreProductInfoDTO.OtherFeatures[0].PackageCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('包装数量')) + ":", 1),
                                    _createTextVNode("  "),
                                    _createElementVNode("span", null, _toDisplayString(data.moreProductInfoDTO.OtherFeatures[0].PackageCount) + " ", 1),
                                    (props.typeCode!='WarnLine')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref($helper).lan('片')), 1))
                                      : _createCommentVNode("", true),
                                    (props.typeCode=='WarnLine')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref($helper).lan('片')), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (data.moreProductInfoDTO.OtherFeatures[0].ECER90)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createTextVNode(" "),
                                  _createElementVNode("span", null, _toDisplayString(data.moreProductInfoDTO.OtherFeatures[0].ECER90), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref($helper).hasPermission('BrandFeatures'))
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_row, {
                      key: 1,
                      class: "MoreProductInfoRow",
                      style: {"padding-bottom":"20px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 2,
                          class: "MoreProductInfoDescript"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($helper).lan('品牌特征')) + ":", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 21 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElTable), {
                              data: _unref(brandProductshow),
                              style: {"width":"100%"},
                              "show-overflow-tooltip": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "Brands",
                                  label: _unref($helper).lan('品牌'),
                                  "min-width": "10%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "BrandsModel",
                                  label: _unref($helper).lan('品牌型号'),
                                  "min-width": "11%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "U9Code",
                                  label: _unref($helper).lan('U9编码'),
                                  "min-width": "12%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "Status",
                                  label: _unref($helper).lan('产品状态'),
                                  "min-width": "10%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "Series",
                                  label: _unref($helper).lan('产品系列'),
                                  "min-width": "10%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "Code69Info",
                                  label: _unref($helper).lan('69码信息'),
                                  "min-width": "13%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "ProductNote",
                                  label: _unref($helper).lan('产品备注'),
                                  "min-width": "10%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "PriceGuidance",
                                  label: _unref($helper).lan('指导价'),
                                  "min-width": "8%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "PriceMedia",
                                  label: _unref($helper).lan('媒体价'),
                                  "min-width": "8%"
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  prop: "StoreQty",
                                  label: _unref($helper).lan('库存'),
                                  "min-width": "8%"
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _unref(brandProductshow).length>0?true:false]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, { name: "3" }, {
              title: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('车型信息')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  class: "MoreProductInfoRow",
                  style: {"padding-bottom":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_el_text, { class: "mx-1 MoreProductInfoDescript" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($helper).lan('市场/来源')), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode("  "),
                          _createVNode(_component_el_select, {
                            modelValue: data.MarketSource,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.MarketSource) = $event)),
                            class: "m-2",
                            placeholder: _unref($helper).lan('全部市场'),
                            style: {"width":"100px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.MarketSources, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: _unref($helper).lan(item),
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"]),
                          _createVNode(_component_el_text, {
                            class: "mx-1 MoreProductInfoDescript",
                            style: {"margin-left":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($helper).lan('详细搜索')), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode("  "),
                          _createVNode(_component_el_input, {
                            modelValue: data.DetailSearch,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.DetailSearch) = $event)),
                            placeholder: _unref($helper).lan('详细搜索'),
                            style: {"width":"100px"},
                            onKeydown: _withKeys(CarModelsInfoMatchSearch, ["enter"])
                          }, null, 8, ["modelValue", "placeholder", "onKeydown"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_el_link, { underline: false }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: {"color":"#000","padding-left":"3px","padding-right":"3px","margin-left":"10px"},
                                onClick: CarModelsInfoMatchSearch
                              }, _toDisplayString(_unref($helper).lan('查询')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_link, { underline: false }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: {"color":"#000","padding-left":"3px","padding-right":"3px","margin-left":"10px"},
                                onClick: searchReset
                              }, _toDisplayString(_unref($helper).lan('重置')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_text, {
                            class: "mx-1 MoreProductInfoDescript",
                            size: "small",
                            style: {"margin-left":"20px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($helper).lan('找到')) + " " + _toDisplayString(data.ShowCarModelsInfoMatchs.length) + " " + _toDisplayString(_unref($helper).lan('条车型')), 1)
                            ]),
                            _: 1
                          }),
                          (_unref($helper).hasPermission('CarModelBaoYouLiang'))
                            ? (_openBlock(), _createBlock(_component_el_text, {
                                key: 0,
                                class: "mx-1 MoreProductInfoDescript",
                                size: "small",
                                style: {"margin-left":"20px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref($helper).lan('总保有量')) + "：" + _toDisplayString(data.TotalRetention), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        (data.lanType=='CN' && _unref($helper).hasPermission('CarModelBaoYouLiang'))
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: data.province,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.province) = $event)),
                              class: "m-2",
                              placeholder: _unref($helper).lan('选择省份'),
                              clearable: "",
                              filterable: "",
                              style: {"width":"120px","margin-top":"3px","margin-left":"5px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getProvinces), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                          : _createCommentVNode("", true),
                        (data.lanType=='CN' && _unref($helper).hasPermission('CarModelBaoYouLiang'))
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 1,
                              modelValue: data.city,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.city) = $event)),
                              class: "m-2",
                              placeholder: _unref($helper).lan('选择城市'),
                              multiple: "true",
                              "collapse-tags": "true",
                              filterable: "",
                              style: {"width":"200px","margin-top":"3px","margin-left":"5px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getCities), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                          : _createCommentVNode("", true),
                        (data.lanType=='CN' && _unref($helper).hasPermission('CarModelBaoYouLiang'))
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 2,
                              modelValue: data.baoYouLiangYear,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.baoYouLiangYear) = $event)),
                              class: "m-2",
                              placeholder: _unref($helper).lan('选择年份'),
                              multiple: "true",
                              "collapse-tags": "true",
                              filterable: "",
                              style: {"width":"120px","margin-top":"3px","margin-left":"5px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.baoYouLiangYears, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.productTypes, (btn) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "rowproductTypeButton",
                            key: btn.type,
                            onClick: ($event: any) => (productTypesClick(btn.code)),
                            style: _normalizeStyle(data.productTypesChecked.indexOf(btn.code)>-1?data.OperateTypeCheckSatyle:'')
                          }, _toDisplayString(_unref($helper).lan(btn.text)), 13, _hoisted_16))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  class: "MoreProductInfoRow",
                  style: {"padding-bottom":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElTable), {
                          data: data.ShowCarModelsInfoMatchs,
                          style: {"width":"100%"},
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "carInfo",
                              label: _unref($helper).lan('详细车型信息'),
                              "min-width": "35%"
                            }, null, 8, ["label"]),
                            (data.productTypesChecked.indexOf('BrakePads')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  prop: "BrakeFront",
                                  label: _unref($helper).lan('前刹车'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.BrakeFront))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(scope.row.BrakeFront), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row.BrakeFront), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('BrakePads')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 1,
                                  prop: "BrakeAfter",
                                  label: _unref($helper).lan('后刹车'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.BrakeAfter))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row.BrakeAfter), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.BrakeAfter), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('HandBrake')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 2,
                                  prop: "HandBrake",
                                  label: _unref($helper).lan('手刹片'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.HandBrake))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.HandBrake), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(scope.row.HandBrake), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('BrakeDisc')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 3,
                                  prop: "BrakeDiscFront",
                                  label: _unref($helper).lan('前刹车盘'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.BrakeDiscFront))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row.BrakeDiscFront), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row.BrakeDiscFront), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('BrakeDisc')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 4,
                                  prop: "BrakeDiscAfter",
                                  label: _unref($helper).lan('后刹车盘'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.BrakeDiscAfter))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(scope.row.BrakeDiscAfter), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(scope.row.BrakeDiscAfter), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('WarnLine')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 5,
                                  prop: "AlarmLineFront",
                                  label: _unref($helper).lan('前报警线'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.AlarmLineFront))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(scope.row.AlarmLineFront), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(scope.row.AlarmLineFront), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('WarnLine')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 6,
                                  prop: "AlarmLineAfter",
                                  label: _unref($helper).lan('后报警线'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.AlarmLineAfter))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(scope.row.AlarmLineAfter), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(scope.row.AlarmLineAfter), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('AnnexPackge')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 7,
                                  prop: "AccessoryPackFront",
                                  label: _unref($helper).lan('前附件包'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.AccessoryPackFront))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(scope.row.AccessoryPackFront), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(scope.row.AccessoryPackFront), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.productTypesChecked.indexOf('AnnexPackge')>-1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 8,
                                  prop: "AccessoryPackAfter",
                                  label: _unref($helper).lan('后附件包'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    (data.procudtCodes.includes(scope.row.AccessoryPackAfter))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(scope.row.AccessoryPackAfter), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(scope.row.AccessoryPackAfter), 1))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (data.lanType=='CN')
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 9,
                                  prop: "Note",
                                  label: _unref($helper).lan('车型匹配区别'),
                                  "min-width": "10%"
                                }, null, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (_unref($helper).hasPermission('CarModelBaoYouLiang'))
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 10,
                                  prop: "OtherRetention",
                                  label: _unref($helper).lan('保有量'),
                                  "min-width": "7%"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createTextVNode(_toDisplayString(OtherRetentionFormat(scope.row.OtherRetention)), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_el_collapse_item, { name: "4" }, {
              title: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('OE信息')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  class: "MoreProductInfoRow",
                  style: {"padding-bottom":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElTable), {
                          data: _unref(brandCodeshow),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "MCType",
                              label: _unref($helper).lan('类别'),
                              "min-width": "20%"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "BrandsOther",
                              label: _unref($helper).lan('品牌'),
                              "min-width": "30%"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "OtherCode",
                              label: _unref($helper).lan('参考编码'),
                              "min-width": "25%"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "Remark",
                              label: _unref($helper).lan('备注'),
                              "min-width": "25%"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(brandCodeshow).length>0]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})